import {Component} from "react";
import "./NavBar.css";
import logo_stc from "../../images/logo_stc_horizontal.png";
import logo_cena_en_rojo_h from "../../images/cena en rojo_horizontal.svg"

export default class NavBar extends Component {
    render() {
        return (
            <nav className="navbar navbar-default">
                <a href="https://savethechildren.mx">
                    <img src={logo_stc} alt="logo_stc"/>
                </a>
                <a href="https://savethechildren.mx">
                    <img src={logo_cena_en_rojo_h} alt="logo_cena_en_rojo"/>
                </a>
            </nav>
        )
    }
}